import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../../utils/app.settings';
import {
  IRolAgente,
  IRolAgentePost,
} from '../../interfaces/agents.interface';

@Injectable({
  providedIn: 'root',
})
export class RolAgenteService {
  constructor(
    private httpClient: HttpClient,
    private appSettings: AppSettings
  ) {}

  /**
   * Obtener todos los roles de agente
   */
  getAllRolAgente(): Observable<IRolAgente[]> {
    const url = this.appSettings.rolAgente.urls.base;
    return this.httpClient.get<IRolAgente[]>(url);
  }

  /**
   * Obtener un rol de agente por UUID
   */
  getRolAgenteByUuid(uuid: string): Observable<IRolAgente> {
    const url = `${this.appSettings.rolAgente.urls.base}/${uuid}`;
    return this.httpClient.get<IRolAgente>(url);
  }

  /**
   * Crear un nuevo rol de agente
   */
  createRolAgente(data: IRolAgentePost): Observable<IRolAgente> {
    const url = this.appSettings.rolAgente.urls.base;
    return this.httpClient.post<IRolAgente>(url, data);
  }

  /**
   * Actualizar un rol de agente existente
   */
  updateRolAgente(
    uuid: string,
    data: IRolAgentePost
  ): Observable<IRolAgente> {
    const url = `${this.appSettings.rolAgente.urls.base}/${uuid}`;
    return this.httpClient.put<IRolAgente>(url, data);
  }

  /**
   * Eliminar un rol de agente
   */
  deleteRolAgente(uuid: string): Observable<void> {
    const url = `${this.appSettings.rolAgente.urls.base}/${uuid}`;
    return this.httpClient.delete<void>(url);
  }
}

